import TpClientPaymentRefundItem from '../Domain/TpClientPaymentRefundItem';
import AuthService from './authService';

export default class TpClientPaymentRefundService {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = {
      Command: '',
      OrderBy: orderById,
      OrderDirection: orderDir,
      PageNumber: pageNumber,
      NumberOfElementsOnAPage: numberOfElements,
      SearchItem: searchItem.TpClientPaymentId,
    };

    const url = `/api/TpClientPaymentRefund/GetPaymentRefundListAsync/?searchParams=${JSON.stringify(
      searchParams
    )}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBItems(itemlist) {
    return itemlist !== null ? itemlist.map((item) => new TpClientPaymentRefundItem(item)) : [];
  }

  static GetById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/TpClientPaymentRefund/GetById/${id ? id : 0}`);
  }
}
